import { render, staticRenderFns } from "./CarisTypeMineSearch.vue?vue&type=template&id=0a35678c&scoped=true"
import script from "./CarisTypeMineSearch.vue?vue&type=script&lang=js"
export * from "./CarisTypeMineSearch.vue?vue&type=script&lang=js"
import style0 from "./CarisTypeMineSearch.vue?vue&type=style&index=0&id=0a35678c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35678c",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcaris-type-mine-search%2FCarisTypeMineSearch.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports